import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
    TileOption,
    TileQuestion,
} from '../tile-question/tile-question.component';

export interface PillQuestion {
    id: number;
    title: string;
    // options: PillOption[];
}

export interface PillOption {
    text: string;
    value: number;
}

export interface PillResponse {
    id: number;
    value: number;
}

@Component({
    selector: 'app-pill-question',
    templateUrl: './pill-question.component.html',
    styleUrls: ['./pill-question.component.scss'],
})
export class PillQuestionComponent implements OnInit {
    @Input() questions: PillQuestion;
    @Input() pillOption :PillOption[];
    @Input() title;
    @Output() changeOption = new EventEmitter<PillResponse[]>();

    selectedOption: PillResponse[] = [] as PillResponse[];

    selectOption(questionId, optionValue) {
        const response: PillResponse = {
            id: questionId,
            value: optionValue,
        };
        if (!this.itemExists(response)) {
            this.selectedOption.push(response);
        } else {
            const index = this.findIndex(response);
            this.selectedOption.splice(index, 1, response);
        }
        this.changeOption.emit(this.selectedOption);
    }

    findIndex(item): number {
        return this.selectedOption.findIndex((x) => x.id === item.id);
    }

    itemExists(item): boolean {
        return this.selectedOption.some((el) => {
            return el.id === item.id;
        });
    }

    checkActiveOption(questionId, value) {
        return this.selectedOption.some((el) => {
            return el.value === value && el.id === questionId;
        });
    }

    constructor() {}

    ngOnInit() {}
}
